import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["real", "additionalValue"]

  toggle(event) {
    const checkbox = this.realTarget
    checkbox.checked = !checkbox.checked
    checkbox.dispatchEvent(new Event("change", { bubbles: true }))

    // Toggle additional values (hidden inputs) enabled/disabled state
    this.toggleAdditionalValues()

    // Update all checked room types
    this.updateAllCheckedRoomTypes()
  }

  getRoomTypeDropdown() {
    const dropdown = document.getElementById("multiple-dropdown-wrapper")
    if (dropdown) {
      const itemsWrapper = dropdown.getElementsByClassName("dropdown-item")

      // Hide all items first
      Array.from(itemsWrapper).forEach(item => {
        if (!item.classList.contains('hidden')) {
          item.classList.add('hidden')
        }
      })

      return itemsWrapper
    }
    return []
  }

  toggleRoomTypesDropdown(event) {
    event.preventDefault()

    // Use ALL checked room types, not just current checkbox
    const roomTypeIds = this.getAllCheckedRoomTypes()

    // If no room types, hide all and return early
    if (roomTypeIds.length === 0) {
      this.getRoomTypeDropdown() // This hides all items
      return
    }

    const items = this.getRoomTypeDropdown()

    // Show only items that match the room type IDs
    Array.from(items).forEach(item => {
      // Find input (checkbox or radio) within the item
      const input = item.querySelector('input[type="checkbox"], input[type="radio"]')

      if (input && roomTypeIds.includes(input.value)) {
        item.classList.remove('hidden')
      }
    })

    // Dispatch custom event with room type IDs
    this.element.dispatchEvent(new CustomEvent('room-types:show', {
      bubbles: true,
      detail: { roomTypeIds: roomTypeIds, checkbox: this.realTarget }
    }))
  }

  toggleAdditionalValues() {
    if (!this.hasAdditionalValueTarget) return

    const isChecked = this.realTarget.checked

    // Enable/disable hidden inputs based on checkbox state
    this.additionalValueTargets.forEach(input => {
      input.disabled = !isChecked
    })
  }

  getAdditionalValues() {
    if (!this.hasAdditionalValueTarget) return []

    return this.additionalValueTargets.map(input => input.value)
  }

  getAllCheckedRoomTypes() {
    // Find all checkboxes with the same controller in the parent container
    const parentElement = this.element.closest('.grid') || document
    const allCheckboxControllers = this.application.controllers.filter(
      controller => controller.identifier === this.identifier &&
        parentElement.contains(controller.element)
    )

    // Collect all room type IDs from checked checkboxes
    const allRoomTypeIds = []

    allCheckboxControllers.forEach(controller => {
      if (controller.realTarget.checked) {
        const roomTypes = controller.getAdditionalValues()
        allRoomTypeIds.push(...roomTypes)
      }
    })

    // Return unique IDs
    return [...new Set(allRoomTypeIds)]
  }

  updateAllCheckedRoomTypes() {
    const uniqueRoomTypeIds = this.getAllCheckedRoomTypes()

    // Update dropdown visibility
    this.uncheckMissingRoomTypes(uniqueRoomTypeIds)
    this.updateDropdownVisibility(uniqueRoomTypeIds)

    // Dispatch event with all unique room types
    this.element.dispatchEvent(new CustomEvent('room-types:updated', {
      bubbles: true,
      detail: { roomTypeIds: uniqueRoomTypeIds }
    }))
  }

  uncheckMissingRoomTypes(uniqueRoomTypeIds) {
    const dropdown = document.getElementById("multiple-dropdown-wrapper")
    if (!dropdown) return

    const checkboxes = dropdown.querySelectorAll('input[type="checkbox"]')

    Array.from(checkboxes).forEach(checkbox => {
      const shouldBeChecked = uniqueRoomTypeIds.includes(checkbox.value)

      if (!shouldBeChecked && checkbox.checked) {
        checkbox.click()
      }
    })
  }

  updateDropdownVisibility(uniqueRoomTypeIds) {
    const dropdown = document.getElementById("multiple-dropdown-wrapper")
    if (!dropdown) return

    const items = dropdown.getElementsByClassName("dropdown-item")

    // Hide all items first
    Array.from(items).forEach(item => {
      if (!item.classList.contains('hidden')) {
        item.classList.add('hidden')
      }
    })

    // If no unique room types, keep everything hidden
    if (uniqueRoomTypeIds.length === 0) {
      return
    }

    // Show only items that match the unique room type IDs
    Array.from(items).forEach(item => {
      const input = item.querySelector('input[type="checkbox"], input[type="radio"]')

      if (input && uniqueRoomTypeIds.includes(input.value)) {
        item.classList.remove('hidden')
      }
    })
  }

  connect() {
    // Initialize additional values state on connect
    this.toggleAdditionalValues()
  }
}
